module.exports = __webpack_public_path__ + "media/img/pages/profile/ckw ger 8-1de5bfb4307df547594e581977c28304.webp";